export const REAL_NAME_MAX_LENGTH = 16
export const REAL_NAME_VALIDATION_MESSAGE = `真实姓名仅支持中文和中点·，且最长${REAL_NAME_MAX_LENGTH}位`

const REAL_NAME_PATTERN = /^(?=.{1,16}$)[\u4e00-\u9fa5]+(?:·[\u4e00-\u9fa5]+)*$/

export const validateRealName = (realName: string): boolean => {
  return REAL_NAME_PATTERN.test(realName.trim())
}

interface RealNameField {
  realName?: string | null
}

export const omitInvalidRealName = <T extends RealNameField>(data: T): T => {
  if (data.realName === undefined || validateRealName(data.realName || '')) {
    return data
  }

  const dataWithoutInvalidRealName = { ...data }
  delete dataWithoutInvalidRealName.realName
  return dataWithoutInvalidRealName
}
